<template>
<section>
  <div class="d-sm-flex justify-content-sm-between align-items-sm-center mb-3">
    <div class="btn-group btn-group-sm mb-3 mb-sm-0" role="group">
      <button type="button" class="btn" v-text="labels[shared.lang].filter0" :class="{'btn-info': options.status===0, 'btn-outline-info': options.status!==0}" @click.prevent="changeStatus(0)"></button>
      <button type="button" class="btn" v-text="labels[shared.lang].filter1" :class="{'btn-info': options.status===1, 'btn-outline-info': options.status!==1}" @click.prevent="changeStatus(1)"></button>
      <button type="button" class="btn" v-text="labels[shared.lang].filter2" :class="{'btn-info': options.status===2, 'btn-outline-info': options.status!==2}" @click.prevent="changeStatus(2)"></button>
      <button type="button" class="btn" v-text="labels[shared.lang].filter4" :class="{'btn-info': options.status===4, 'btn-outline-info': options.status!==4}" @click.prevent="changeStatus(4)"></button>
      <button type="button" class="btn" v-text="labels[shared.lang].filter3" :class="{'btn-info': options.status===3, 'btn-outline-info': options.status!==3}" @click.prevent="changeStatus(3)"></button>
    </div>
    <HomeSearchBox :field="options.field" :keyword="options.keyword" @search="changeKeyword" />
  </div>
  
  <div class="alert alert-secondary" role="alert" v-if="page > 0">{{ labels[shared.lang].search1 }} : <strong v-text="all_count"></strong>{{ labels[shared.lang].search2 }} : <strong v-text="max_count"></strong>{{ labels[shared.lang].search3 }}</div>
  
  <div class="table-responsive" v-if="page > 0">
  <table class="table table-sm table-striped table-hover">
  <thead class="thead-light">
    <tr>
      <th scope="col" class="text-center" style="width:50px">-</th>
      <th scope="col" style="min-width:180px">
        <a href="#" @click.prevent="changeSort('name')">{{ labels[shared.lang].name }} <span v-if="options.sort==='name'">{{ options.direction==='desc'?'&#9660;':'&#9650;' }}</span></a>
      </th>
      <th scope="col" style="width:100px">
        <a href="#" @click.prevent="changeSort('chocomint')">{{ labels[shared.lang].chocomint }} <span v-if="options.sort==='chocomint'">{{ options.direction==='desc'?'&#9660;':'&#9650;' }}</span></a>
      </th>
      <th scope="col">
        <a href="#" @click.prevent="changeSort('office')">{{ labels[shared.lang].company }} <span v-if="options.sort==='office'">{{ options.direction==='desc'?'&#9660;':'&#9650;' }}</span></a>
      </th>
      <th scope="col" style="width:100px">
        <a href="#" @click.prevent="changeSort('datetime')">{{ labels[shared.lang].regdt }} <span v-if="options.sort==='datetime'">{{ options.direction==='desc'?'&#9660;':'&#9650;' }}</span></a>
      </th>
      <th v-if="shared.user" scope="col" class="text-center" style="width:50px">-</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in list">
      <td class="align-middle text-center"><button type="button" class="btn btn-sm btn-info" v-text="labels[shared.lang].details" @click.prevent="move('/details/'+item.idx)"></button></td>
      <td class="align-middle">{{ item.name_ja }}<span v-if="item.name_ko && shared.lang=='ko'">({{ item.name_ko }})</span></td>
      <td class="align-middle">{{ item.status|chocomint }}</td>
      <td class="align-middle">{{ item.office }}<span v-if="item.office_ko && shared.lang=='ko'">({{ item.office_ko }})</span></td>
      <td class="align-middle">{{ item.edit_dt.substring(0,10) }}</td>
      <td class="align-middle text-center" v-if="shared.user"><button type="button" class="btn btn-sm btn-secondary" v-text="labels[shared.lang].edit" @click.prevent="move('/edit/'+item.idx)"></button></td>
    </tr>
  </tbody>
  </table>
  </div>
  
  <nav aria-label="Page navigation" class="mt-3" v-if="page > 0">
    <ul class="pagination justify-content-center">
      <li class="page-item" v-if="start_page>0">
        <a class="page-link" href="#" tabindex="-1" @click.prevent="changePage(start_page+1)">&laquo;</a>
      </li>
      <li class="page-item" v-for="i in 10" v-if="start_page+i<=max_page" :class="{active: start_page+i === page}">
        <a class="page-link" href="#" v-text="start_page+i"  @click.prevent="changePage(start_page+i)"></a>
      </li>
      <li class="page-item" v-if="start_page+10<max_page">
        <a class="page-link" href="#" tabindex="-1" @click.prevent="changePage(start_page+11)">&raquo;</a>
      </li>
    </ul>
  </nav>
  
</section>
</template>

<script>
'use strict'
import axios from 'axios'
import { labels } from '../label.js'
import { shared } from '../state.js'
import HomeSearchBox from '@/components/HomeSearchBox'
axios.defaults.withCredentials = true

export default {
  name: 'HomeCtrl',
  components: {
    HomeSearchBox
  },
  data() {
    return {
      labels: labels,
      shared: shared,
      
      list: null,
      page: 0,
      all_count: 0,
      max_count: 0,
      max_page: 0,
      start_page: 0,
      
      options: {},
    }
  },
  filters: {
    chocomint(value) {
      switch(value) {
      case 1:
        return labels[shared.lang].filter1
      case 2:
        return labels[shared.lang].filter2
      case 3:
        return labels[shared.lang].filter3
      case 4:
        return labels[shared.lang].filter4
      default:
        return labels[shared.lang].filter5
      }
    },
  },
  created() {
    shared.initLanguage()
    this.initSocialTag()
    this.parse(this.$route)
  },
  computed: {},
  beforeRouteUpdate(to, from, next) {
    this.parse(to)
    next()
  },
  methods: {
    move(path) {
      this.$router.push(path)
    },
    parse(route) {
      this.options.status = route.query.status ? parseInt(route.query.status) : 0
      this.options.field = route.query.field ? route.query.field : 'name'
      this.options.keyword = route.query.keyword ? route.query.keyword : ''
      this.options.sort = route.query.sort ? route.query.sort : 'datetime'
      this.options.direction = route.query.direction ? route.query.direction : 'desc'
      
      let page = Math.max(1, route.query.page ? parseInt(route.query.page) : 1)
      this.search(page)
    },
    search(page) {
      this.options.page = page
      this.options.lang = shared.lang
      
      axios.get(`${shared.apiroot}1.1/list`, {params: this.options}).then((resp)=> {
        this.list = resp.data.list
        this.page = resp.data.page
        this.max_page = resp.data.max_page
        this.max_count = resp.data.max_count
        this.all_count = resp.data.all_count
        this.start_page = parseInt(Math.floor((this.page - 1) / 10.0) * 10)
      }).catch(()=>{})
    },
    
    changeKeyword(payload) {
      if(this.options.field === payload.field && this.options.keyword === payload.keyword) return
      
      this.options.field = payload.field
      this.options.keyword = payload.keyword
      this.options.page = 1
      
      this.pushQuery(this.options)
    },
    changeStatus(value) {
      if(this.options.status === value) return
      
      this.options.status = value
      this.options.page = 1
      
      this.pushQuery(this.options)
    },
    changeSort(value) {
      this.options.direction = this.options.sort === value && this.options.direction === 'asc' ? 'desc' : 'asc'
      this.options.sort = value
      
      this.pushQuery(this.options)
    },
    changePage(value) {
      if(this.page === value) return
      
      this.options.page = value
      
      this.pushQuery(this.options)
    },
    pushQuery(options) {
      let query = {}
      if(options.status !== 0) query.status = options.status
      if(options.page > 1) query.page = options.page
      if(options.field !== 'name') query.field = options.field
      if(options.keyword) query.keyword = options.keyword
      if(!(options.sort === 'datetime' && options.direction === 'desc')) {
        query.sort = options.sort
        query.direction = options.direction
      }
      
      this.$router.push({path: '/', query: query})
    },
    
    initSocialTag() {
      document.title = labels[shared.lang].title
      document.querySelector('meta[property="og:title"]').setAttribute('content', document.title)
      document.querySelector('meta[property="og:image"]').setAttribute('content', `${shared.root}static/images/chocomint.png`)
      document.querySelector('meta[property="twitter:image"]').setAttribute('content', `${shared.root}static/images/chocomint.png`)
    },
  },
}
</script>

<style scoped>
table {
  min-width: 700px;
}
.alert {
  padding: .5rem 1rem;
}
</style>
